// ============================================
// OPTIMIZED JAVASCRIPT FOR PERTH PADEL SHOP
// ============================================

document.addEventListener("DOMContentLoaded", function() {
  // UTILITIES & HELPERS
  const isMobile = () => window.innerWidth <= 768;
  const isDesktop = () => window.innerWidth > 768;
  
  // Debounce function for performance
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // ============================================
  // 1. EXTERNAL LINKS MANAGEMENT
  // ============================================
  const handleExternalLinks = () => {
    // Generic external links
    const menuLinks = document.querySelectorAll('nav a, .m-menu__link');
    menuLinks.forEach(link => {
      const href = link.getAttribute('href');
      
      // Handle external links
      if (href && href.startsWith('http') && !href.includes(window.location.hostname)) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
      
      // Specific coaching links
      if (link.textContent.trim() === 'Coaching' || 
          (href && href.includes('perthpadelcoach.com'))) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  };

  // ============================================
  // 2. MOBILE PRODUCT CARD OPTIMIZATION
  // ============================================
  const optimizeMobileProductCards = () => {
    if (isDesktop()) return;

    const productCards = document.querySelectorAll(".m-product-card");
    productCards.forEach(card => {
      const wishlistBtn = card.querySelector(".m-wishlist-button");
      const media = card.querySelector(".m-product-card__media");

      if (wishlistBtn && media && !media.contains(wishlistBtn)) {
        // Add positioning styles
        media.style.position = 'relative';
        wishlistBtn.style.position = 'absolute';
        wishlistBtn.style.bottom = '4px';
        wishlistBtn.style.right = '8px';
        wishlistBtn.style.zIndex = '10';
        
        media.appendChild(wishlistBtn);
      }
    });
  };

  // ============================================
  // 3. ENHANCED ECOMSEND POPUP OPTIMIZATION
  // ============================================
  const optimizeEcomsendPopup = () => {
    if (isDesktop()) return;

    const popupStyles = {
      title: { fontSize: '11px' },
      helpText: { fontSize: '10px' },
      description: { fontSize: '10px' },
      button: { 
        fontSize: '10px', 
        padding: '4px 6px',
        transition: 'all 0.2s ease'
      },
      input: {
        fontSize: '10px',
        padding: '2px 4px',
        height: '24px',
        width: '100%',
        margin: '0 auto',
        display: 'block',
        borderRadius: '4px',
        border: '1px solid #ddd'
      },
      span: {
        fontSize: '10px',
        lineHeight: '1.1'
      },
      logo: {
        boxShadow: 'none',
        filter: 'none',
        maxHeight: '40px'
      }
    };

    const popoverStyles = {
      backgroundColor: '#000 !important',
      color: '#fff !important',
      padding: '4px 8px !important',
      height: '28px !important',
      minHeight: '28px !important',
      minWidth: '150px !important',
      maxWidth: '180px !important',
      width: 'fit-content !important',
      whiteSpace: 'nowrap !important',
      borderRadius: '4px !important',
      boxSizing: 'border-box !important',
      display: 'inline-flex !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',
      lineHeight: '1.1 !important',
      textAlign: 'center !important',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15) !important'
    };

    const applyStyles = (element, styles) => {
      if (!element) return;
      Object.entries(styles).forEach(([prop, value]) => {
        if (prop.includes('!important')) {
          element.style.setProperty(prop.replace('!important', '').trim(), value);
        } else {
          element.style[prop] = value;
        }
      });
    };

    const observer = new MutationObserver(() => {
      // Handle popup dialog
      const popupWrapper = document.querySelector(".ecomsend__Modal__Dialog");
      if (popupWrapper) {
        const elements = {
          title: popupWrapper.querySelector(".ecomsend__Modal__TitleText"),
          helpText: popupWrapper.querySelector(".ecomsend__Modal__TitleHelpText"),
          description: popupWrapper.querySelector("[class*='Description']"),
          button: popupWrapper.querySelector("button"),
          logo: popupWrapper.querySelector("img, ._myLogoImg_rds7d_112")
        };

        // Apply styles to specific elements
        Object.entries(elements).forEach(([key, element]) => {
          if (element && popupStyles[key]) {
            applyStyles(element, popupStyles[key]);
          }
        });

        // Handle inputs and spans
        popupWrapper.querySelectorAll("input, textarea").forEach(input => 
          applyStyles(input, popupStyles.input)
        );
        
        popupWrapper.querySelectorAll("span, p, label").forEach(span => 
          applyStyles(span, popupStyles.span)
        );
      }

      // Handle popover
      const popover = document.querySelector(".ecomsend__Popover__Widget__CustomContainer.ecomsend__Popover__Widget__left._mobile_left_1qtor_30");
      if (popover) {
        Object.entries(popoverStyles).forEach(([prop, value]) => {
          popover.style.setProperty(prop.replace(/([A-Z])/g, '-$1').toLowerCase(), value);
        });

        const span = popover.querySelector("span");
        if (span) span.style.fontSize = "9.5px";
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  // ============================================
  // 4. PERFORMANCE ENHANCEMENTS
  // ============================================
  
  // Lazy loading for images
  const initLazyLoading = () => {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.classList.remove('lazy');
            observer.unobserve(img);
          }
        }
      });
    });

    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  };

  // Smooth scrolling for anchor links
  const initSmoothScrolling = () => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  };

  // ============================================
  // 5. MOBILE TOUCH ENHANCEMENTS
  // ============================================
  const initTouchEnhancements = () => {
    if (isDesktop()) return;

    let touchStartX, touchStartY;
    const threshold = 100;

    const handleTouchStart = (e) => {
      const touch = e.touches[0];
      touchStartX = touch.pageX;
      touchStartY = touch.pageY;
    };

    const handleTouchEnd = (e) => {
      if (!touchStartX || !touchStartY) return;

      const touch = e.changedTouches[0];
      const touchEndX = touch.pageX;
      const touchEndY = touch.pageY;
      
      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;

      // Only handle horizontal swipes
      if (Math.abs(deltaX) > threshold && Math.abs(deltaY) < 100) {
        if (deltaX > 0) {
          // Swipe right - could trigger navigation
          console.log('Swipe right detected');
        } else {
          // Swipe left - could trigger navigation
          console.log('Swipe left detected');
        }
      }

      // Reset values
      touchStartX = touchStartY = null;
    };

    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });
  };

  // ============================================
  // 6. ANALYTICS TRACKING (Optional)
  // ============================================
  const trackEvent = (category, action, label) => {
    if (typeof gtag !== 'undefined') {
      gtag('event', action, {
        event_category: category,
        event_label: label
      });
    }
  };

  const initAnalytics = () => {
    // Track product clicks
    document.querySelectorAll('.m-product-card').forEach(card => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('.m-wishlist-button')) return;
        const productName = card.querySelector('.m-product-card__title')?.textContent?.trim();
        if (productName) {
          trackEvent('Product', 'click', productName);
        }
      });
    });

    // Track wishlist interactions
    document.querySelectorAll('.m-wishlist-button').forEach(btn => {
      btn.addEventListener('click', (e) => {
        // Let the delegated wishlist handler receive the click.
        trackEvent('Wishlist', 'toggle', 'product_wishlist');
      });
    });
  };

  // ============================================
  // 7. RESPONSIVE HANDLING
  // ============================================
  const handleResize = debounce(() => {
    optimizeMobileProductCards();
  }, 250);

  // ============================================
  // 8. INITIALIZATION
  // ============================================
  const init = () => {
    // Core functionality
    handleExternalLinks();
    optimizeMobileProductCards();
    optimizeEcomsendPopup();
    
    // Performance enhancements
    initLazyLoading();
    initSmoothScrolling();
    
    // Mobile enhancements
    initTouchEnhancements();
    
    // Analytics (optional)
    initAnalytics();
    
    // Event listeners
    window.addEventListener('resize', handleResize);
    
    console.log('Perth Padel Shop - JavaScript optimized and loaded ✅');
  };

  // Start everything
  init();
});

// ============================================
// 9. UTILITY FUNCTIONS (Global scope)
// ============================================

// Loading state helper
window.addLoadingState = (button, text = 'Chargement...') => {
  button.dataset.originalText = button.innerHTML;
  button.innerHTML = `<span class="spinner" style="
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #333;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-right: 8px;
  "></span>${text}`;
  button.disabled = true;
};

window.removeLoadingState = (button) => {
  if (button.dataset.originalText) {
    button.innerHTML = button.dataset.originalText;
    delete button.dataset.originalText;
  }
  button.disabled = false;
};

// CSS for spinner animation
if (!document.querySelector('#spinner-styles')) {
  const style = document.createElement('style');
  style.id = 'spinner-styles';
  style.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
}


